module.exports = __webpack_public_path__ + "img/quick-start-guide_zh.308b687a.jpg";